import React, {Component} from 'react';
import TextBlock from "../../TextBlock/TextBlock";
import QuoteBlock from "../../QuoteBlock/QuoteBlock";
import classroom from "../../../images/classroom.png";
import workers from "../../../images/workers.png";
import ann from "../../../images/ann-troka.png";
import jeremy from "../../../images/jeremy-behle.png";
import lab from "../../../images/lab.png";
import teamwork from "../../../images/teamwork.png";
import phone from "../../../images/phone.png";
import "./Family.css";

/**
 * Family
 */
export default class Family extends Component {

    /**
     * Default Props
     *
     * @type {{className: string, textBlocks: {blockBiz: {text1: string, text2: string}, growingOurOwn: string, meaningfulIntro: {text1: string, text2: string}, working: string}}}
     */
    static defaultProps = {
        className: 'family',
        textBlocks: {
            blockBiz: {
                text1: "Keeping with our commitment to effective, transparent communications, we launched a new video series for our family members: Block Biz. Although we’ve been hosting in-person monthly business updates with our CEO for some time, we understood that not every employee could always physically make it to the meetings.",
                text2: "Hosted by our Chief Financial Officer Jeremy Behler, Block Biz is a video series that covers three things with every episode: a breakdown of our financial performance, a rotating special topic and employee recognition. The Sargento Family can watch when they’re able on our intranet, The Block, or on the network of televisions in our breakrooms, called Block TV. Check out an example:"
            },
            growingOurOwn: "With unemployment at record lows in Wisconsin, especially in Sheboygan County where Sargento is headquartered, we redoubled our efforts to deepen our pool of potential employees by forging connections with the next generation workforce. Our CEO, Louie Gentine, played an active leadership role with Sheboygan County Chamber of Commerce in launching  an initiative to help cultivate the local workforce of tomorrow—due in part to statistics about Wisconsin’s workforce, which suggest there is considerable room for growth.",
            meaningfulIntro: {
                text1: "Because giving back is essential to our culture at Sargento, we took a different approach to our new employee orientation sessions in 2017. During the first half of the day long sessions, members of the Sargento Family discuss the values we hold as a company, such as Sense of Ownership, Humor and Fun, Balance in Life and more. The second half is spent in a hands-on experience at a local non-profit organization, giving our new employees a chance to practice our belief in  community outreach.",
                text2: "The interactive approach was a hit with our new employees, who in some cases had their first experience volunteering. The charities were equally ecstatic, benefiting from much-needed help from Sargento. The Sheboygan Press took notice of our immersive approach and profiled our effort in the March 8, 2017 edition."
            },
            working: "In March of 2017, we debuted a new employee app, “Sargento at Work,” to help our family members stay better connected to company information and each other. Over the course of the year, we collected employee feedback and worked continuously to improve the app’s functionality, making it a more social experience. "
        }
    };

    /**
     * Component will receive props
     *
     * @param {object} nextProps
     */
    componentWillReceiveProps(nextProps) {
        if (this.props.className !== nextProps.className) {
            this.setState({
                className: nextProps.className
            });
        }
    }

    /**
     * Render
     *
     * @returns {*}
     */
    render() {

        const {className, textBlocks} = this.props;
        const {blockBiz, growingOurOwn, meaningfulIntro, working} = textBlocks;

        return (
            <div className={className}>
                <div className="layout">
                    <div className="column">
                        <TextBlock title="Growing Our Own"
                                   text={growingOurOwn}/>

                        <div className="para_border">
                            <h2>Sheboygan County, Wis., has more jobs available than people to fill them.
                                Unemployment is below three percent!</h2>
                        </div>

                        <div className="classroom scale">
                            <img src={lab}
                                 alt="Lab"/>
                        </div>

                        <div className="classroom scale">
                            <img src={classroom}
                                 alt="Classroom"/>
                        </div>

                        <TextBlock title="A Meaningful Introduction"
                                   textObject={meaningfulIntro}/>

                        <div className="workers scale">
                            <img src={workers}
                                 alt="Workers"/>
                        </div>

                        <div className="working">
                            <TextBlock title="A New Way of Working"
                                       text={working}/>
                        </div>

                        <TextBlock title="Block Biz"
                                   textObject={blockBiz}/>
                    </div>

                    <div className="column">
                    <p className="hide-on-desktop">Check out an example below</p>
                        <div className="person">
                            <img src={ann}
                                 alt="Anne"/>
                            <span><h4>Anne Troka</h4></span>
                            <p>To benefit both the community and our company, Louie hired a
                               Workforce Development liaison, Anne Troka, to “grow our own”— in
                               other words, create a clear path for local youth to become future
                               members of the Sargento Family.</p>
                            <p>Anne formalized several programs and created new Strategic Workforce Planning
                               initiatives to meet business needs during her first full year in Workforce
                               Development, including:</p>
                        </div>

                        <div className="list_border">
                            <span>CAREER COACH</span>
                            <p>a volunteer opportunity for Sargento
                               employees to provide career guidance to high school, technical
                               school and college/university students</p>
                        </div>
                        <div className="list_border">
                            <span>CAREER EXPERIENCES</span>
                            <p>a career exploration experience
                               allowing students to talk to current employees working in their
                               fields of career interest</p>
                        </div>
                        <div className="list_border">
                            <span>YOUTH CO-OP</span>
                            <p>a nine-week experience for a high
                               school junior or senior to work directly with employees in operations,
                               manufacturing and/or engineering</p>
                        </div>
                        <div className="list_border">
                            <span>YOUTH APPRENTICESHIPS</span>
                            <p>a 450-hour work experience from
                               June through May for a high school junior or senior to work hands-on
                               at Sargento</p>
                        </div>
                        <div className="list_border">
                            <span>INTERNSHIP</span>
                            <p>a 10 to 12-week work experience for
                               a college junior or senior</p>
                        </div>
                        <div className="list_border">
                            <span>CO-OP</span>
                            <p>a single semester of work experience
                               for college juniors or seniors to work on large projects</p>
                        </div>
                        <div className="list_border">
                            <span>SUMMER STUDENT TEMP</span>
                            <p>a summer-long opportunity for
                               technical school or college students to perform routine work</p>
                        </div>

                        <div className="teamwork scale">
                            <img src={teamwork}
                                 alt="Teamwork"/>
                        </div>

                        <QuoteBlock quote="It really goes to the heart of the company. We are investing in our employees and making sure they have the tools that they need, but we also give back and invest in our community.”"
                                    author="Kerry Kramer"
                                    source="Senior Vice President – Manufacturing &amp; Engineering"/>

                        <div className="phone scale">
                            <img src={phone}
                                 alt="Phone"/>
                        </div>

                        <div className="person jeremy">
                            <img src={jeremy}
                                 alt="Jeremy"/>
                            <span>
                  <h4>JEREMY BEHLER</h4>
                </span>
                        </div>
                    </div>
                </div>

                <div className="layout">
                    {/* <div className="videowrapper"> */}
                        {/* <iframe title="Awards Video"
                                allowFullScreen
                                frameBorder="0"
                                height="664"
                                mozallowfullscreen="true"
                                src="https://player.vimeo.com/video/262293291"
                                webkitallowfullscreen="true"
                                width="800"/> */}


                                <iframe title="Family Video"
                                    id="kaltura_player_1530551062" 
                                    src="https://cdnapisec.kaltura.com/p/2169031/sp/216903100/embedIframeJs/uiconf_id/36602371/partner_id/2169031?iframeembed=true&playerId=kaltura_player_1530551062&entry_id=1_9g843ch2&flashvars[streamerType]=auto" 
                                    width="768" 
                                    height="655"
                                    allowFullScreen 
                                    webkitallowfullscreen="true"
                                    mozallowfullscreen="true"
                                    frameBorder="0"></iframe>
                    {/* </div> */}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Family/Family.jsx